import React, { useState } from 'react';
import './ImageUrlUploader.css';

const ImageUrlUploader = ({imageUrls, setImageUrls, }) => {
  const [currentInput, setCurrentInput] = useState('');
  const [imageErrors, setImageErrors] = useState({});

  const addImageUrl = () => {
    if (currentInput.trim() && imageUrls.length < 10) {
      const newUrl = currentInput.trim();
      setImageUrls([...imageUrls.filter(url => url), newUrl]);
      setCurrentInput('');
      // Clear any previous error for this URL
      setImageErrors(prev => ({ ...prev, [newUrl]: false }));
    }
  };

  const handleImageError = (url) => {
    setImageErrors(prev => ({ ...prev, [url]: true }));
  };

  const removeImage = (index) => {
    const updated = imageUrls.filter((_, i) => i !== index);
    setImageUrls(updated.length === 0 ? [''] : updated);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      addImageUrl();
    }
  };

  const isValidUrl = (url) => {
    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  };

  const validUrls = imageUrls.filter(url => url && isValidUrl(url));

  return (
    <div className="image-uploader-container">
      <h2 className="image-uploader-title">Upload Job Image</h2>
      
      {/* Input Section */}
      <div className="input-section">
        <div className="input-row">
          <input
            type="url"
            placeholder="Paste image URL here..."
            value={currentInput}
            onChange={(e) => setCurrentInput(e.target.value)}
            onKeyPress={handleKeyPress}
            className="url-input"
            disabled={imageUrls.filter(url => url).length >= 10}
          />
          <button
            onClick={addImageUrl}
            disabled={!currentInput.trim() || imageUrls.filter(url => url).length >= 10}
            className="add-button"
          >
            Add Image
          </button>
        </div>
        
        <div className="image-counter">
          {imageUrls.filter(url => url).length} / 10 images added
        </div>
      </div>

      {/* Images Grid */}
      {validUrls.length > 0 && (
        <div className="images-grid">
          {validUrls.map((url, index) => (
            <div key={index} className="image-item">
              <div className="image-container">
                <img
                  src={url}
                  alt={`Uploaded image ${index + 1}`}
                  className="image-preview"
                  onError={() => handleImageError(url)}
                  onLoad={() => setImageErrors(prev => ({ ...prev, [url]: false }))}
                  crossOrigin="anonymous"
                />
                {imageErrors[url] && (
                  <div className="error-overlay">
                    <div className="error-content">
                      <svg className="error-icon" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                      </svg>
                      <p className="error-text">Error</p>
                    </div>
                  </div>
                )}
              </div>
              
              {/* Remove Button */}
              <button
                onClick={() => removeImage(imageUrls.indexOf(url))}
                className="remove-button"
              >
                <svg className="remove-icon" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </button>
            </div>
          ))}
        </div>
      )}

      {/* Empty State */}
      {validUrls.length === 0 && (
        <div className="empty-state">
          <svg className="empty-icon" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z" clipRule="evenodd" />
          </svg>
          <p className="empty-text">No images added yet. Paste an image URL above to get started!</p>
        </div>
      )}
    </div>
  );
};

export default ImageUrlUploader;